import { useFlow } from '@/shared/lib/steps-flow'

interface GetBorderColorParams {
  hasSelection?: boolean
  isSelected?: boolean
  borderColor?: string
}

export function useBorderColor() {
  const { state } = useFlow()

  let borderColor = 'border-gray-200'
  if (state.phase == 'CORRECT') {
    borderColor = 'border-green-500'
  } else if (state.phase == 'LOCKED_WRONG') {
    borderColor = 'border-red-500'
  }

  const getBorderColor = (props: GetBorderColorParams = {}) => {
    const {
      hasSelection = false,
      isSelected = false,
      borderColor: _borderColor = 'border-gray-200'
    } = props
    let borderColor = _borderColor

    if (state.phase == 'CORRECT' && (!hasSelection || isSelected)) {
      borderColor = 'border-green-500'
    } else if (state.phase == 'LOCKED_WRONG' && (!hasSelection || isSelected)) {
      borderColor = 'border-red-500'
    } else if (hasSelection && isSelected) {
      borderColor = 'border-primary'
    }

    return borderColor
  }

  return { borderColor, getBorderColor }
}
